import React, { useEffect, useState } from "react";
import { HiEye } from "react-icons/hi";
import { toast } from "react-toastify";
import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch } from 'react-redux';
import { FaStar, FaStarHalfAlt, FaRegStar, FaExclamationTriangle, FaInfoCircle } from "react-icons/fa";
import 'yet-another-react-lightbox/styles.css';
import Lightbox from 'yet-another-react-lightbox';
import Swal from 'sweetalert2';
import { IoMdArrowRoundBack } from "react-icons/io";
import { MdDelete, MdModeEdit, MdVerified } from "react-icons/md";
import ApiClient from "../../api-client";
import pdf from "../../assets/img/pdf.svg"
import Modal from 'react-modal';
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  CardTitle,
  CardText,
  Button,
  Label,
  Spinner,
  CardImg,
  Table,
} from "reactstrap";

function ProviderDetails() {
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [loader, setLoader] = useState(false);
  const [alertLoader, setAlertLoader] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [userDetails, setUserDetails] = useState(null);
  const [userRating, setUserRating] = useState(0);
  const [url, setUrl] = useState(null);
  const [showAlter, setShowAlter] = useState(false);
  const [userServiceDetails,setUserServiceDetails]=useState([])
  const fullStars = Math.floor(userRating);
  const hasHalfStar = userRating % 1 !== 0;
  const emptyStars = 5 - Math.ceil(userRating);
  const [action, setAction] = useState(null);
  const [serviceId, setServiceId] = useState(null);
  const [userId, setUserId] = useState(null);
  const openLightbox = (originalUrl) => {
    setUrl(originalUrl)
    setIsOpen(true);
  };

 
  const closeLightbox = () => {
    setIsOpen(false);
    setUrl(null);
  };

  const queryParams = new URLSearchParams(location.search);
  const id = queryParams.get("id");

  const fetchDetails = async () => {
    try {
      setLoader(true);
      const getDetails = await ApiClient.get(
        `api/users/get-user-by-id/${id}`,
        "",
        true,
        dispatch
      );
      if (getDetails?.body) {
        setUserRating(getDetails?.body?.rating?.averageRating);
      }if(getDetails?.body?.isVerified){
        fetchServiceDetails()
      }
      setUserDetails(getDetails.body);
      setLoader(false);
    } catch (error) {
      toast.error(error.message, { autoClose: 3000 });
      setLoader(false);
    }
  };

  const fetchServiceDetails = async () => {
    try {
      setLoader(true);
      const getDetails = await ApiClient.get(
        `api/service/get-service-by-provider-id/${id}`,
        "",
        true,
        dispatch
      );

      if (getDetails?.body) {
       setUserServiceDetails(getDetails?.body?.allServices);
      }
      // setUserDetails(getDetails.body);
      setLoader(false);
    } catch (error) {
      // toast.error(error.message, { autoClose: 3000 });
      setLoader(false);
    }
  };

      useEffect(() => {
        fetchDetails();
     }, []);

  
  const loadDoduments = (
    thumbnailDocuments,
    name,
    originalthumbnailDocuments
  ) => {

    return  thumbnailDocuments.map((document, index) => {
      const isPdf = document.key.endsWith('.pdf');
           return (
                    isPdf ? (
                    <div
                      key={index}
                      className="image-card-container"    
                    >
                        <Card className="image-card">
                            <CardImg top width="100%" src={pdf} alt="Card image cap" />
                            <CardBody>
                              <CardText>{name}</CardText>
                            </CardBody>
                            <div className="overlay">
                              <a href={originalthumbnailDocuments[index]?.url} target="_blank">
                              <HiEye className="icon"/>
                              </a>
                            </div>
                          </Card>
                    
                          </div>) : (
      
                        <div
                          key={index}
                          className="image-card-container"
                          onClick={() => openLightbox(originalthumbnailDocuments[index]?.url)}
                        >
                         <>
                        <Card className="image-card">
                          <CardImg top width="100%" src={document.url} alt="Card image cap" />
                          <CardBody>
                            <CardText>{name}</CardText>
                          </CardBody>
                          <div className="overlay">
                            <HiEye className="icon" />
                          </div>
                        </Card>
                      </>
                      </div>)
                          );
                      });
                      };

  const handleConfirm = async () => {
    if (userId) {
      try {
        setAlertLoader(true);
        const verfifyProvider = await ApiClient.put(
          `api/admin/update-provider-status`,
          { id:userId },
          true,
          dispatch
        );
        setAlertLoader(false);
        setShowAlter(false);
        fetchDetails();
        toast.success(verfifyProvider.message, { autoClose: 3000 });
      } catch (error) {
        setAlertLoader(false);
        toast.error(error.message, { autoClose: 3000 });
      }
    }
  };
  const formatDate = dateString => new Date(dateString).toLocaleDateString('en-GB', { day: '2-digit', month: 'long', year: 'numeric' });

  const handleDelete = async () => {
    if (serviceId) {
      try {
        setAlertLoader(true);
        const deleteUser = await ApiClient.put(
          `service/update-service-status/${serviceId}`,
          { action: "isDeleted", actionValue: "true" },
          true,
          dispatch
        );
        setAlertLoader(false);
        setShowAlter(false);
        fetchServiceDetails();
        toast.success(deleteUser.message, { autoClose: 3000 });
      } catch (error) {
        setAlertLoader(false);
        toast.error(error.message, { autoClose: 3000 });
      }
    }
  };

  const handleStatus = async () => {
    if (serviceId) {
      try {
        setAlertLoader(true);
        const updateUserStatus = await ApiClient.put(
          `api/service/update-service-status/${serviceId}`,
          { action: "status", actionValue: action },
          true,
          dispatch
        );
        setAlertLoader(false);
        setShowAlter(false);
        fetchServiceDetails();
        toast.success(updateUserStatus.message, { autoClose: 3000 });
      } catch (error) {
        setAlertLoader(false);
        toast.error(error.message, { autoClose: 3000 });
      }
    }
  };

  const openAlertDialog = (id, action) => {
    console.log(id, 'id');
    setServiceId(id);
    setUserId(id)
    setAction(action);
    setShowAlter(true);

  };

  const getActionIcon = () => {
    return action === "delete" ? <FaExclamationTriangle /> : <FaInfoCircle />;
  };

  const viewDetails = (id) => {
  
    navigate(`/admin/provider/details/service?id=${id}`);
  };
 const handleUpdateServiceDetails = (serviceid)=>{
  navigate(`/admin/provider/details/update-service-details?id=${serviceid}`,{
    state: {  providerId:id , serviceId:serviceid }
  });
 }


  return (
    <>
      <div className="content">
        <Button
          color="primary"
          className="ml-10 common-button"
          onClick={() => navigate("/admin/provider/list")}
        >
          <IoMdArrowRoundBack /> Back
        </Button>
        <Container>
          {loader && (
            <span className="table-loader">
              <Spinner color="primary">Loading...</Spinner>
            </span>
          )}
          {!loader && (
            <>
              <Card>
                <CardBody className="mb-15">
                  <div>
                    <Row>
                      <Col md="10">
                        <div className="card-heading">
                        <Label>Basic Details</Label>
                        </div>
                      </Col>
                      <Col md="2">
                        {!userDetails?.isVerified && (
                          <Button
                            color="primary"
                            className="common-button"
                            // onClick={() => setShowAlter(true)}
                            onClick={() => openAlertDialog(userDetails._id,'verify')}
                          >
                            Verify
                          </Button>
                        )}
                        {userDetails?.isVerified && (
                          <>
                            <MdVerified className="verified-badge" />
                            <strong>verified</strong>
                          </>
                        )}
                      </Col>
                    </Row>
                  </div>
                  <div>
                    <Row>
                      <Col md="4" className="profile-card">
                        <img
                          src={userDetails?.profilePic?.url || require("assets/img/default-avatar.png")}
                          alt="User"
                          className="rounded-circle img-fluid profile-rounded-img"
                        />
                        <CardTitle tag="h5" className="mt-3">
                          {`${userDetails?.firstName} ${userDetails?.lastName}`}
                        </CardTitle>
                        <CardText>
                          <div className="star-rating">
                            {[...Array(fullStars)].map((_, index) => (
                              <FaStar
                                key={index}
                                className="star"
                                color="#ffc107"
                              />
                            ))}
                            {hasHalfStar && (
                              <FaStarHalfAlt className="star" color="#ffc107" />
                            )}
                            {[...Array(emptyStars)].map((_, index) => (
                              <FaRegStar
                                key={index}
                                className="star"
                                color="#e4e5e9"
                              />
                            ))}
                            ({userDetails?.rating?.totalRating}) rates
                          </div>
                        </CardText>
                      </Col>
                      <Col md="8">
                        <CardBody>
                          <Row className="mt-3">
                            <Col md="4">
                              <strong>First Name:</strong>{" "}
                              {userDetails?.firstName
                                ? userDetails?.firstName
                                : "-"}
                            </Col>
                            <Col md="4">
                              <strong>Last Name:</strong>{" "}
                              {userDetails?.lastName
                                ? userDetails?.lastName
                                : "-"}
                            </Col>
                            <Col md="4">
                              <strong>Phone Number:</strong>{" "}
                              {userDetails?.phoneNumber
                                ? userDetails?.phoneNumber
                                : "-"}
                            </Col>
                          </Row>
                          <Row className="mt-3">
                            <Col md="6">
                              <strong>Email:</strong>{" "}
                              {userDetails?.email ? userDetails?.email : "-"}
                            </Col>
                            <Col md="3">
                              <strong>Gender:</strong>{" "}
                              {userDetails?.gender ? userDetails?.gender : "-"}
                            </Col>
                            <Col md="3">
                              <strong>DOB:</strong>{" "}
                              {userDetails?.dateOfBirth
                                ? formatDate(userDetails?.dateOfBirth)
                                : "-"}
                            </Col>
                          </Row>
                          <Row className="mt-3">
                            <Col md="6">
                              <strong>Address1:</strong>{" "}
                              {userDetails?.address1
                                ? userDetails?.address1
                                : "-"}
                            </Col>
                            <Col md="6">
                              <strong>Address2:</strong>{" "}
                              {userDetails?.address2
                                ? userDetails?.address2
                                : "-"}
                            </Col>
                          </Row>
                          <Row className="mt-3">
                            <Col md="3">
                              <strong>Pincode:</strong>{" "}
                              {userDetails?.pincode
                                ? userDetails?.pincode
                                : "-"}
                            </Col>
                            <Col md="5">
                              <strong>City:</strong>{" "}
                              {userDetails?.city ? userDetails?.city : "-"}
                            </Col>
                          </Row>
                          <Row className="mt-3">
                            <Col md="4">
                              <strong>Specialties:</strong>{" "}
                              {userDetails?.specialties
                                ? userDetails?.specialties
                                : "-"}
                            </Col>
                            <Col md="4">
                              <strong>Qualifications:</strong>{" "}
                              {userDetails?.qualifications
                                ? userDetails?.qualifications
                                : "-"}
                            </Col>
                            <Col md="4">
                              <strong>Experience:</strong>{" "}
                              {userDetails?.experience
                                ? userDetails?.experience
                                : "-"}
                            </Col>
                          </Row>
                        </CardBody>
                      </Col>
                    </Row>
                  </div>
                </CardBody>
              </Card>
              <Card>
                <CardBody className="mb-15">
                  <div className="card-heading">
                  <Label>Verification Document</Label>
                  </div>
                  <div className="document-flex-box">
                    {userDetails?.addressVerificationDocThumbnail.length > 0 &&
                      loadDoduments(
                        userDetails?.addressVerificationDocThumbnail,
                        "Address Verification Document",
                        userDetails?.addressVerificationDoc
                      )}
                    {userDetails?.identityVerificationDocThumbnail.length > 0 &&
                      loadDoduments(
                        userDetails?.identityVerificationDocThumbnail,
                        "Identity Verification Document",
                        userDetails?.identityVerificationDoc
                      )}
                    {userDetails?.certificateDocThumbnail.length > 0 &&
                      loadDoduments(
                        userDetails?.certificateDocThumbnail,
                        "Certificate Document",
                        userDetails?.certificateDoc
                      )}
                    {userDetails?.criminalRecordReportDocThumbnail.length > 0 &&
                      loadDoduments(
                        userDetails?.criminalRecordReportDocThumbnail,
                        "Criminal Record Document",
                        userDetails?.criminalRecordReportDoc
                      )}
                    {userDetails?.recentPhotoThumbnail.length > 0 &&
                      loadDoduments(
                        userDetails?.recentPhotoThumbnail,
                        "Recent Photos",
                        userDetails?.recentPhoto
                      )}
                    {userDetails?.insuranceDocThumbnail.length > 0 &&
                      loadDoduments(
                        userDetails?.insuranceDocThumbnail,
                        "Insurance Document",
                        userDetails?.insuranceDoc
                      )}
                  </div>
                  {isOpen && (
                    <Lightbox mainSrc={url} onCloseRequest={closeLightbox} />
                  )}
{/* 
                  {isPdfOpen && (
                    <a href={url} target="_blank"></a>
                  )} */}


                </CardBody>
              </Card>

              { userDetails?.isVerified && userServiceDetails && userServiceDetails?.length > 0 &&
              <Card>
              <CardBody className="mb-15">
              <Col md="10">
                        <div className="card-heading">
                        <Label>Service Details</Label>
                        </div>
                      </Col>

                <Table responsive>
                      <thead>
                        <tr>
                          <th>Service Title</th>
                          <th>Description</th>
                          <th>Category</th>
                          <th>Created Date</th>
                          <th>Status</th>

                          <th className="text-center">Action</th>
                        </tr>
                      </thead>
                      <tbody>
                        {userServiceDetails?.map((article) => {
                          return (
                            <tr key={article?._id}>
                              <td>{article?.serviceTitle}</td>
                              <td>{article?.description}</td>
                              <td>{article?.categoryId?.categoryName}</td>
                              <td>{formatDate(article?.createdAt)}</td>
                              {/* <td>{article?.status}</td> */}
                              <td>
                              {article?.status && article?.status == "activated" ? (
                                <Button
                                  onClick={() =>
                                    openAlertDialog(article?._id, "deactivated")
                                  }
                                  className="common-button"
                                >
                                  Activated
                                </Button>
                              ) : (
                                <Button
                                  onClick={() =>
                                    openAlertDialog(article?._id, "activated")
                                  }
                                  className="common-button-danger"
                                >
                                  Deactivated
                                </Button>
                              )}
                            </td>
                              <td className="text-center">
                              <span
                                  className="action-icon"
                                   onClick={() => viewDetails(article._id)}
                                >
                                  <HiEye />
                                </span>
                                <span className="action-icon action-icon-yellow"

                                  onClick={() => handleUpdateServiceDetails(article._id)}
                                 >

                                  <MdModeEdit />
                                </span>
                                <span
                                  className="action-icon action-icon-red"
                                 onClick={() => openAlertDialog(article._id,'delete')}
                                >
                                  <MdDelete />
                                </span>
                              </td>
                            </tr>
                          );
                        })}
                      </tbody>
                    </Table>  
                    </CardBody>
              </Card>
}
            </>
          )}
          {/* {showAlter && (
            <Swal
              info
              showCancel
              confirmBtnText={
                alertLoader ? (
                  <span>
                    Confirm <Spinner size="sm" />
                  </span>
                ) : (
                  "Confirm"
                )
              }
              confirmBtnBsStyle="info"
              title="Are you sure?"
              onConfirm={handleConfirm}
              onCancel={() => setShowAlter(false)}
              focusCancelBtn
            >
              You want to verfify this service provider
            </Swal>
          )} */}

          {showAlter && (
            <Swal
              customIcon={getActionIcon()} // Use customIcon for the icon
              showCancel
              confirmBtnText={
                alertLoader ? (
                  <span>
                    Confirm <Spinner size="sm" />
                  </span>
                ) : (
                  "Confirm"
                )
              }
              confirmBtnBsStyle={`${action === "delete" ? "danger" : "info"}`}
              title="Are you sure?"
              onConfirm={() => {
                if (action === "delete") {
                  handleDelete();
                } else if (action === "verify") {
                  handleConfirm();
                } else {
                  handleStatus();
                }
              }}
              onCancel={() => setShowAlter(false)}
              focusCancelBtn
            >
                {action === 'verify' ? 'You want to verify this service provider.' : `You want to ${action} this service.`}
            </Swal>
          )}

        </Container>
      </div>
    </>
  );
}

export default ProviderDetails;